import React, { useCallback, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";

import PageLayout from "../../_layout/PageLayout";
import { ViewOrganizationProjectProperties } from "../../../services/authorization/Permissions";
import {
  DisplayProjectPropertyLabel,
  DisplayProjectPropertyType,
} from "./components/DataComponents";
import {
  ActionsSection,
  ButtonsSection,
  DataSection,
  SubSection,
} from "../../../components/data-components/sections/DataSections";
import "./ProjectProperties.scss";
import { api } from "../../../services/api/ApiService";
import useUrlParams from "../../../services/url/UrlParamsService";
import { CurrentProjectPropertyStorageModel } from "../../../services/organization/CurrentProjectPropertyStorage";
import { CustomPropertyModel } from "../../../components/data-components/CustomProperty";
import DeleteButton from "../../../components/buttons/delete-button/DeleteButton";
import { useHistory } from "react-router-dom";
import useErrorHandler, {
  ApplicationError,
} from "../../../services/error-handler/ErrorHandlerService";
import { SettingsMenuItemsModel, SettingsMenuItemsPages } from "../SettingsMenuItems";
import { snackbarNotificationsService } from "../../../services/notifications/SnackbarNotificationsService";

export default observer(() => {
  const history = useHistory();
  const urlParamsService = useUrlParams();
  const { handleErrorInSnackbar } = useErrorHandler();

  const projectPropertyId = urlParamsService.getProjectPropertyId()!;

  const [projectPropertyStorage] = useState(() =>
    CurrentProjectPropertyStorageModel.create({ projectPropertyId: projectPropertyId }, { api })
  );

  const [settingsMenuItems] = useState(() =>
    SettingsMenuItemsModel.create({
      menuItemPage: SettingsMenuItemsPages.ViewProjectProperty,
      projectPropertyId: projectPropertyId,
    })
  );

  const menuItems = { staticItems: settingsMenuItems.getStaticItems() };

  const customProperty = useMemo(() => {
    var customPropertyModel = CustomPropertyModel.create(
      {
        ...projectPropertyStorage.currentProjectProperty,
      },
      { api }
    );

    return customPropertyModel;
  }, [projectPropertyStorage.currentProjectProperty]);

  const handleDeleteProject = useCallback(async () => {
    try {
      await projectPropertyStorage.deleteProperty();
      history.push("/settings/project-properties");
      snackbarNotificationsService.showSuccess("custom-project-property.delete.success");
    } catch (error) {
      const applicationError = error as ApplicationError;
      applicationError.withErrorMessage("default-error.custom-project-property.delete");
      handleErrorInSnackbar(applicationError);
    }
  }, [handleErrorInSnackbar, history, projectPropertyStorage]);

  return (
    <div>
      <PageLayout
        accessWithOneOfThePermissions={[ViewOrganizationProjectProperties]}
        id="view-project-properties"
        titleKey="custom-project-properties.view.title"
        titleContext={{ propertyLabel: projectPropertyStorage.currentProjectProperty.label }}
        menuItems={menuItems}
      >
        <ActionsSection>
          <ButtonsSection>
            <DeleteButton
              confirmationAction={handleDeleteProject}
              confirmationModalTitleKey="custom-project-property.delete"
              confirmationModalSubtitleKey="custom-project-property.delete.confirmation"
            />
          </ButtonsSection>
        </ActionsSection>
        <>
          <DataSection labelKey="custom-project-properties.property.details">
            <SubSection>
              <DisplayProjectPropertyLabel customProjectProperty={customProperty} />
            </SubSection>
            <SubSection>
              <DisplayProjectPropertyType customProjectProperty={customProperty} />
            </SubSection>
          </DataSection>
        </>
      </PageLayout>
    </div>
  );
});
